{
  "app": {
    "name": "WebTemplate",
    "tagline": "Modern SaaS Template"
  },
  "nav": {
    "dashboard": "Dashboard",
    "settings": "Settings",
    "admin": "Admin",
    "users": "Users",
    "logout": "Log out",
    "profile": "Profile",
    "settingsAccount": "Account",
    "settingsBilling": "Billing",
    "settingsSecurity": "Security",
    "settingsNotifications": "Notifications",
    "settingsPrivacy": "Privacy",
    "adminDashboard": "Overview",
    "home": "Go to dashboard",
    "sidebarLabel": "Sidebar navigation",
    "mainLabel": "Main navigation",
    "mobileLabel": "Mobile navigation",
    "mobileMenuLabel": "Mobile navigation menu",
    "collapseSidebar": "Collapse sidebar",
    "expandSidebar": "Expand sidebar",
    "openMenu": "Open navigation menu",
    "userMenu": "User menu"
  },
  "settings": {
    "account": {
      "title": "Account",
      "description": "Manage your profile, personal details, and preferences.",
      "profileTitle": "Profile",
      "profileDescription": "Your identity across the platform.",
      "firstNameLabel": "First name",
      "lastNameLabel": "Last name",
      "emailLabel": "Email address",
      "emailHint": "Used for sign-in and account notifications.",
      "notSet": "Not set",
      "statusLabel": "Account status",
      "memberSinceLabel": "Member since",
      "preferencesTitle": "Preferences",
      "preferencesDescription": "Tailor the interface to how you work.",
      "languageLabel": "Language",
      "languageHint": "Changes the language used across the app."
    },
    "security": {
      "title": "Security",
      "description": "Manage your password and protect your account.",
      "passwordTitle": "Password",
      "passwordDescription": "Set a strong, unique password to keep your account secure.",
      "passwordHint": "Send yourself a reset link to choose a new password.",
      "changePassword": "Change password",
      "twoFactorTitle": "Two-factor authentication",
      "twoFactorDescription": "Add a second step at sign-in for an extra layer of protection.",
      "twoFactorDisabled": "Not enabled",
      "twoFactorHint": "Use an authenticator app to generate one-time codes.",
      "enableTwoFactor": "Enable two-factor",
      "sessionsTitle": "Active sessions",
      "sessionsDescription": "Devices currently signed in to your account.",
      "sessionsEmptyTitle": "No other active sessions",
      "sessionsEmptyDescription": "When you sign in from another device, it will show up here."
    }
  },
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "closeDialog": "Close dialog",
    "closePanel": "Close panel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "loading": "Loading...",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "submit": "Submit",
    "retry": "Try again"
  },
  "status": {
    "success": "Success",
    "error": "Error",
    "warning": "Warning",
    "info": "Information"
  },
  "account": {
    "status": {
      "active": "Active",
      "disabled": "Disabled",
      "inactive": "Inactive",
      "locked": "Locked",
      "pending": "Pending verification"
    },
    "role": {
      "superAdmin": "Super-admin",
      "admin": "Admin",
      "user": "User"
    }
  },
  "errors": {
    "notFound": "Page not found",
    "notFoundDescription": "The page you are looking for does not exist.",
    "unexpected": "Something went wrong",
    "unexpectedDescription": "An unexpected error occurred.",
    "goHome": "Go to Dashboard"
  },
  "featureNotAvailable": {
    "title": "Feature Not Available",
    "description": "This feature is currently disabled. Contact your administrator."
  },
  "language": {
    "label": "Language",
    "en": "English",
    "es": "Spanish",
    "fr": "French"
  },
  "admin": {
    "nav": {
      "tenants": "Tenants",
      "analytics": "Platform analytics",
      "tenantAnalytics": "Analytics",
      "site": "Site",
      "siteAnalytics": "Site analytics",
      "featureFlags": "Feature Flags",
      "plugins": "Plugins"
    },
    "clearFilters": "Clear filters",
    "loadError": "We couldn't load this data. Try again in a moment.",
    "tenants": {
      "title": "Manage Tenants",
      "description": "View and manage platform tenants.",
      "createTenant": "Create Tenant",
      "searchPlaceholder": "Search by name or slug...",
      "colName": "Name",
      "colSlug": "Slug",
      "colStatus": "Status",
      "colUsers": "Users",
      "colCreated": "Created",
      "emptyState": "No tenants found.",
      "loadingState": "Loading tenants...",
      "createTitle": "Create New Tenant",
      "nameLabel": "Tenant Name",
      "nameRequired": "Name must contain at least one non-whitespace character",
      "namePlaceholder": "e.g. Acme Corp",
      "slugLabel": "Slug",
      "slugPlaceholder": "acme-corp",
      "slugHelp": "URL-friendly identifier (auto-generated from name)",
      "detailTitle": "Tenant Details",
      "detailInfo": "Information",
      "detailName": "Name",
      "detailSlug": "Slug",
      "detailStatus": "Status",
      "detailUsers": "Users",
      "detailCreated": "Created",
      "detailUpdated": "Last Updated",
      "editName": "Edit Name",
      "saveName": "Save",
      "statusActive": "Active",
      "statusDisabled": "Disabled",
      "statusSuspended": "Suspended",
      "confirmDisable": "Disable Tenant",
      "confirmDisableMessage": "Are you sure you want to disable \"{{name}}\"? Users will not be able to access this tenant.",
      "confirmEnable": "Enable Tenant",
      "confirmEnableMessage": "Are you sure you want to enable \"{{name}}\"?",
      "brandingTitle": "Branding",
      "brandingDescription": "Customize the look and feel of this tenant.",
      "brandingLogoUrl": "Logo URL",
      "brandingLogoPlaceholder": "https://example.com/logo.png",
      "brandingPrimaryColor": "Primary Color",
      "brandingAccentColor": "Accent Color",
      "brandingFontFamily": "Font Family",
      "brandingFontPlaceholder": "e.g. Inter, system-ui",
      "brandingPreview": "Preview",
      "brandingSave": "Save Branding",
      "brandingSaved": "Branding saved successfully",
      "brandingPreviewSidebar": "Sidebar",
      "brandingPreviewDashboard": "Dashboard",
      "brandingPreviewSettings": "Settings",
      "brandingPreviewButton": "Action",
      "settingsLocale": "Locale",
      "settingsLocalePlaceholder": "en",
      "authPreferencesTitle": "Authentication preferences",
      "authRequireTwoFactor": "Require two-factor authentication",
      "authAllowedMethods": "Allowed sign-in methods",
      "authMethodPassword": "Password",
      "authMethodMagicLink": "Magic link",
      "authMethodTotp": "Authenticator app (TOTP)"
    },
    "featureFlags": {
      "title": "Feature Flags",
      "description": "Manage feature flags to control feature rollout across tenants and users.",
      "createFlag": "Create Flag",
      "emptyTitle": "No feature flags yet",
      "emptyState": "No feature flags configured yet. Create your first flag to get started.",
      "colName": "Name",
      "colType": "Type",
      "colStatus": "Status",
      "colLastModified": "Last Modified",
      "statusEnabled": "Enabled",
      "statusDisabled": "Disabled",
      "toggleLabel": "Toggle {{name}}",
      "confirmToggle": "Confirm Toggle",
      "toggleMessage": "Are you sure you want to change \"{{name}}\" to {{status}}?",
      "affectedTenants": "This will affect {{count}} tenant(s).",
      "affectedPercentage": "This applies to {{value}}% of users.",
      "affectedSegments": "This applies to {{count}} segment(s).",
      "auditTrail": "Audit Trail",
      "noAuditEntries": "No changes recorded yet.",
      "changedBy": "Changed by",
      "fieldName": "Name",
      "fieldKey": "Key",
      "fieldDescription": "Description",
      "fieldType": "Flag Type",
      "namePlaceholder": "e.g. Dark Mode Beta",
      "keyHint": "Lowercase letters, digits, and hyphens only (kebab-case).",
      "descriptionPlaceholder": "Optional description of this flag's purpose.",
      "type": {
        "boolean": "Boolean",
        "percentage": "Percentage Rollout",
        "tenant": "Tenant-Scoped",
        "segment": "User Segment"
      },
      "percentageLabel": "Rollout Percentage",
      "percentageValue": "Percentage value",
      "tenantIdsLabel": "Tenant IDs",
      "tenantIdsPlaceholder": "tenant-a, tenant-b",
      "tenantIdsHint": "Comma-separated list of tenant IDs.",
      "segmentsLabel": "Segments",
      "segmentsPlaceholder": "beta-testers, early-adopters",
      "segmentsHint": "Comma-separated list of user segment names."
    },
    "plugins": {
      "title": "Plugin Management",
      "description": "Manage installed plugins and their availability.",
      "name": "Name",
      "version": "Version",
      "descriptionCol": "Description",
      "capabilities": "Capabilities",
      "status": "Status",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "noPlugins": "No plugins registered yet.",
      "toggleLabel": "Toggle {{name}}"
    },
    "users": {
      "title": "Manage Users",
      "description": "View and manage platform users.",
      "inviteUser": "Invite User",
      "searchPlaceholder": "Search by name or email...",
      "filterAll": "All Statuses",
      "filterActive": "Active",
      "filterDisabled": "Disabled",
      "colName": "Name",
      "colEmail": "Email",
      "colStatus": "Status",
      "colRole": "Role",
      "colTenant": "Tenant",
      "colCreated": "Created",
      "colActions": "Actions",
      "viewUser": "View details for {{name}}",
      "emptyState": "No users found.",
      "noResultsTitle": "No matching users",
      "noResultsDescription": "No users match your current search and filters.",
      "loadingState": "Loading users...",
      "statusActive": "Active",
      "statusDisabled": "Disabled",
      "statusLocked": "Locked",
      "statusPending": "Pending",
      "statusInactive": "Inactive",
      "detail": {
        "title": "User Details",
        "email": "Email",
        "firstName": "First Name",
        "lastName": "Last Name",
        "status": "Status",
        "roles": "Roles",
        "created": "Created",
        "lastLogin": "Last Login",
        "editInfo": "Edit User Info",
        "saveChanges": "Save Changes",
        "toggleStatus": "Toggle Status",
        "enableUser": "Enable User",
        "disableUser": "Disable User",
        "resetPassword": "Reset Password",
        "confirmDisable": "Are you sure you want to disable {{name}}? They will lose access immediately.",
        "confirmEnable": "Are you sure you want to enable {{name}}?",
        "confirmPasswordReset": "Send a password reset email to {{email}}?",
        "passwordResetSent": "Password reset email sent.",
        "statusUpdated": "User status updated.",
        "infoUpdated": "User info updated."
      },
      "invite": {
        "title": "Invite User",
        "email": "Email Address",
        "emailPlaceholder": "user@example.com",
        "role": "Role",
        "roleTenantAdmin": "Tenant Admin",
        "roleUser": "User",
        "send": "Send Invitation",
        "success": "Invitation sent successfully.",
        "invalidEmail": "Please enter a valid email address."
      },
      "pagination": {
        "previous": "Previous",
        "next": "Next",
        "page": "Page {{current}} of {{total}}"
      }
    }
  }
}
